import Modal from "react-modal";
import Icon from "../common/Icon";
import MyInfoAccount from "./MyInfoAccount";
import MyInfoPersonal from "./MyInfoPersonal";
import MyInfoVerification from "./MyInfoVerification";

const MyInfoModal = ({ open, data, onClose }) => {
  return (
    <>
      {open && (
        <Modal
          ariaHideApp={false}
          className="h-full text-center flex"
          isOpen={open}
          onRequestClose={onClose}
        >
          <div className="card bg-white w-full md:w-5/12 md:shadow-xl m-auto p-4 overflow-hidden md:max-h-[66.6667%] md:h-min h-full">
            <div className="card-body overflow-y-auto scrollbar-hide">
              <h2 className="text-2xl font-bold text-start">내 정보</h2>
              <MyInfoAccount data={data} />
              <MyInfoPersonal data={data} />
              <MyInfoVerification data={data} />
            </div>
            <div className="card-actions w-full">
              <button
                className="btn btn-ghost bg-zinc-300 btn-sm w-full"
                onClick={onClose}
              >
                <Icon name="x" size="sm" className="inline-block" />
                닫기
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default MyInfoModal;
